import React from "react";
import { Alert } from "antd";
import { observer } from "mobx-react-lite";
import MultiPlatformEwaybillResultStore from "./MultiPlatformEwaybillResultStore";

interface EwaybillResultAlertProps {
    store: MultiPlatformEwaybillResultStore;
}

const EwaybillResultAlert: React.FC<EwaybillResultAlertProps> = function (props) {
    const { store } = props;

    let copies: string | number;

    if (store.useMaxQuantityPerPackage) {
        copies = "自动分包";
    } else {
        copies = store.copies;
    }

    return (
        <Alert
            title={
                <div>
                    <p>
                        <span style={{ fontSize: 16, fontWeight: "bold" }}>
                            <span className="mr5">获取单号数：{store.generateSuccessCount}</span>
                            {store.generateErrorCount > 0 ? (
                                <span className="text-error">失败数：{store.generateErrorCount}</span>
                            ) : null}
                            <span className="mr5">，发送到打印机成功：{store.printSuccessCount}</span>
                            {store.printErrorCount > 0 ? (
                                <span className="text-error">
                                    失败：
                                    {store.printErrorCount}
                                </span>
                            ) : null}
                            <span>；</span>

                            {!store.isGenerateWaybillNoOnly && store.waitingSendCount > 0 ? (
                                <span className="text-error">
                                    剩余发送到打印机数：
                                    {store.waitingSendCount}
                                </span>
                            ) : null}
                        </span>
                    </p>
                    {store.printErrorCount > 0 ? (
                        <p>
                            <a target="_blank" href="https://qw15p3s8hv.feishu.cn/wiki/wikcnnSbpEvK9CNtbxFJM9pGTcg">
                                发送失败单号如何重新打印？
                            </a>
                        </p>
                    ) : null}

                    {store.generateSuccessCount > 0 ? (
                        store.isGenerateWaybillNoOnly ? (
                            <p style={{ fontSize: 16, fontWeight: "bold" }}>仅获取电子面单号不打印！</p>
                        ) : (
                            <div>
                                <p style={{ fontSize: 16, fontWeight: "bold" }}>
                                    全部打印完成后，核对面单的数量和内容打印正确后再发货
                                </p>
                                <p>
                                    <a
                                        target="_blank"
                                        href="https://qw15p3s8hv.feishu.cn/wiki/wikcnEd7bb9mUkFT7RAxxWZc5Kh"
                                    >
                                        如果打印机没有反应，请点击这里查看解决方法
                                    </a>
                                </p>
                            </div>
                        )
                    ) : null}
                </div>
            }
            type={"info"}
            className="mb10"
        />
    );
};

export default observer(EwaybillResultAlert);
